// Logika murni buat dropdown yang nyari ke backend. Tanpa efek samping.

/**
 * Gabungin opsi yang lagi terpilih ke hasil pencarian, biar labelnya gak
 * ilang pas hasil pencarian berganti. Gak nambah duplikat kalau opsinya
 * udah ada di `options` (dibandingin lewat `value`, longgar String()).
 * @param {Array<{value:*, text:string}>} options
 * @param {{value:*, text:string}|null|undefined} selected
 * @returns {Array<{value:*, text:string}>}
 */
export function mergeSelectedOption(options, selected) {
  const list = Array.isArray(options) ? options : [];
  if (!selected || selected.value === null || selected.value === undefined || selected.value === '') {
    return list;
  }
  const exists = list.some((option) => String(option.value) === String(selected.value));
  return exists ? list : [selected, ...list];
}

/**
 * Ambil baris yang persis cocok dari hasil pencarian LIKE (mis. cari "70"
 * bisa ikut nangkep "170"). Bandingin longgar lewat String().
 * @param {Array<Object>} rows
 * @param {string} keyField
 * @param {*} value
 * @returns {Object|null}
 */
export function pickExactMatch(rows, keyField, value) {
  const list = Array.isArray(rows) ? rows : [];
  const hit = list.find((row) => String(row[keyField]) === String(value));
  return hit || null;
}
